import { Component, OnInit } from '@angular/core';
import { SessionStateService } from '../../../../core/services/session-state.service';

@Component({
  selector: 'app-coachmark-users',
  templateUrl: './coachmark-users.component.html',
  styleUrls: ['./coachmark-users.component.scss']
})
export class CoachmarkUsersComponent implements OnInit {
show: boolean;
  constructor(private sessionStateService: SessionStateService) { }

  ngOnInit() {
    this.show = true;
    this.loadAddUser();
  }

  gotIt() {
    this.show = false;
    this.sessionStateService.setCoachMarkIndividualState(this.sessionStateService.getCoachMarkIndividualState().set('users', false));
  }

  loadAddUser() {
    const renderWait = setInterval( () => {
      const elem = document.getElementById('add');
      if (elem) {
        const elemPosition: ClientRect = elem.getBoundingClientRect();
        if ($('#gotIt').length === 1) {
          $('#gotIt').css('left', elemPosition.left - 175);
          $('#gotIt').css('top', elemPosition.top + window.scrollY - 100);
          $('#gotIt').css('display', 'block');
        }
        clearInterval(renderWait);
      }
    }, 500);

    if ($('#add').length === 1) {
      $('#add').css('position', 'relative').css('z-index', '1000');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/coachmarks/coachmark-users/coachmark-users.component.ts